const features_bugs = {
	bugs: {
		add_dialog: {
			title: "Report a Bug",
		},
		report_button: "Report",
		show_all: "Show all bugs",
		title: "Bugs",
	},
	features: {
		add_dialog: {
			inputs: {
				description: "Description",
				image_added: "Image uploaded",
				image_delete: "Delete Image",
				image_upload: {
					description: "Accepted formats: .jpg, .jpeg, .png. </br>File size should not exceed 5MB.",
					image_too_large: "The image size cannot exceed 5MB.",
					something_wrong: "Something went wrong. Please try again later.",
					title: "Optional: Upload Image",
				},
				title: "Title",
			},
			title: "Request a Feature",
		},
		request_button: "Request",
		show_all: "Show all features",
		title: "Features",
	},
	title: "Features & Bugs",
};

export default features_bugs;
